import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import 'bootstrap/dist/css/bootstrap.css';
import "./assets/css/master.css";

ReactDOM.render(<App />, document.getElementById("root"));
